import { getLocale, msg } from '@tov-plus/ui';
import { formatGuestDateTime } from './guestLocale';

const previewModeKeys: Readonly<Record<string, string>> = {
  public_landing: 'reviewer.preview_mode.public_landing',
  invited_guest: 'reviewer.preview_mode.invited_guest',
  rsvp_pending: 'reviewer.preview_mode.rsvp_pending',
  rsvp_complete: 'reviewer.preview_mode.rsvp_complete',
  event_day: 'reviewer.preview_mode.event_day',
};

export function formatReviewerPreviewMode(value: string) {
  return Object.hasOwn(previewModeKeys, value)
    ? msg(previewModeKeys[value]!)
    : value;
}

export function formatReviewerPassGuidance(mode: string, expiresAt: string) {
  const values: Record<string, string> = {
    mode: formatReviewerPreviewMode(mode),
    expires: expiresAt,
  };
  return msg('reviewer.valid_pass_guidance').replace(
    /\{(mode|expires)\}/g,
    (_, name: string) => values[name]!,
  );
}

export function formatReviewerTarget(kind: 'route' | 'section', value: string) {
  return msg(
    kind === 'route' ? 'reviewer.route_target' : 'reviewer.section_target',
  ).replace('{target}', () => value);
}

export function formatReviewerExpiry(value: string, timezone?: string | null) {
  return formatGuestDateTime(value, getLocale(), timezone);
}
